class FantasticProductBox extends HTMLElement {
  constructor() {
    super();
    this.variantSwitcher = document.querySelector("variant-radios");
    this.buyButton = document.querySelector("product-form");
    this.priceProduct = this.querySelector(".price");
    this.errorMessage = this.querySelector(".ff-variant-error-message");
    this.buttonSubmit = document.querySelector(".ff-form-submit-primary");
    this.errorMsg = document.querySelector(".product-form__error-message-wrapper");
    this.isGiftCard = document.querySelector(".product__gift-card");

    const fixedBox = document.querySelector('.ff-fixed-box-product-page');

    if(this.buttonSubmit) this.checkVariantSelected(this.buttonSubmit);
    window.innerWidth <= 749 && !fixedBox && !this.isGiftCard && (this.createNode());
  }

  checkVariantSelected(buttonSubmit) {
    let url = new URL(window.location.href);
    const isVariant = document.querySelector('.ff-variant-selector-options');
    
    if (!url.searchParams.has("variant") && isVariant) {
      const messageError = document.querySelectorAll(".ff-variant-error-message");
      const variantRadios = document.querySelectorAll(
        ".ff-variant-radio-option"
      );
      const productInput = document.querySelector("#ff-form-input-id");
      productInput.value = "";
      variantRadios.forEach((data) => {
        data.checked = false;
      });
      
      const labelsOptions = this.querySelectorAll(
        ".ff-variant-selector-options label"
      );
      
      labelsOptions.forEach((data) => {
        data.addEventListener("click", () => {
          this.toogleErrorMessage(messageError, true);
        });
      });
      buttonSubmit.addEventListener("click", (e) => {
        url = new URL(window.location.href);
        if (!url.searchParams.has("variant") && isVariant) {
          e.preventDefault();
          this.toogleErrorMessage(messageError, false);
          window.scrollTo({ top: 0, behavior: "smooth"});
        }
      });
    }
  }

  toogleErrorMessage(messageError, hide) {
    messageError.forEach(message => {
      hide ?
        message.classList.add("ff-hide")   
      :
        (message.classList.remove("ff-hide"),
        message.innerHTML = message.dataset.variantMessage)
      ;
    })
  }
  createNode() {
    const fixedBox = document.createElement("div");
    const errorMsgDiv = document.createElement("div");
    const newDiv = document.createElement("div");

    fixedBox.classList.add("ff-fixed-box-product-page");
    errorMsgDiv.classList.add("ff-errors-msg");
    newDiv.classList.add("ff-fixed-buy-box");

    const errorMsg = this.errorMsg.cloneNode(true);
    errorMsgDiv.appendChild(errorMsg);
    this.hideElement(this.errorMsg);

    //adding variant switcher
    const newVariantSwitcher =
      this.variantSwitcher && this.variantSwitcher.cloneNode(true);
    const newBuyButtonForm = this.buyButton && this.buyButton.cloneNode(true);
    const listVariant =
      newVariantSwitcher &&
      newVariantSwitcher.querySelector(".ff-variant-selector-options");

    this.variantSwitcher &&
      (newVariantSwitcher.classList.add("ff-full-section-box"), newDiv.appendChild(newVariantSwitcher),
      this.hideElement(this.variantSwitcher));

    //adding price
    const newPriceProduct =
      this.priceProduct && this.priceProduct.cloneNode(true);
    newPriceProduct.innerHTML = "";
    this.priceProduct && newDiv.appendChild(newPriceProduct);

    //adding buy button
    const newBuyButton = newBuyButtonForm.querySelector("button");
    
    !this.variantSwitcher && (newBuyButtonForm.style.flexBasis = "100%");
    
    this.variantSwitcher && (newBuyButton.style.justifyContent = "flex-end");

    this.buyButton && newDiv.appendChild(newBuyButtonForm);
    this.hideElement(this.buyButton);

    newDiv.prepend(errorMsgDiv);
    fixedBox.appendChild(newDiv);
    this.prepend(fixedBox);

    this.changeSizes(newVariantSwitcher, fixedBox, newBuyButtonForm, newPriceProduct);
    this.checkVariantSelected(newBuyButton);

    listVariant && (listVariant.style.bottom = `${fixedBox.clientHeight}px`,
      this.listennerVariantSwitcher(newVariantSwitcher, newPriceProduct, errorMsg)
    )

    window.addEventListener("scroll", (event) => {
      //this.isInViewport(fixedBox);
    });
  }

  changeSizes(variantSwitcher, parentBox, buyButton, priceBox) {
    //const heightBpx = parentBox.clientHeight;
    const heightBpx = 80;
    buyButton.style.height = `${heightBpx}px`;
    priceBox.style.height = `${heightBpx}px`;
    variantSwitcher &&
      (variantSwitcher.style.height = `${heightBpx}px`);
  }

  listennerVariantSwitcher(variantSwitcher, newPriceProduct, errorMsg) {
    const opener = variantSwitcher.querySelector(".form__label");
    const root = document.querySelector(":root"); 
    const labelsOptions = this.querySelectorAll(
      ".ff-variant-selector-options label"
    );

    labelsOptions.forEach((data) => {
      data.addEventListener("click", (e) => {
        data.classList.contains("ff-stock-false") ? e.preventDefault()
        : (variantSwitcher.classList.remove("ff-full-section-box"),
        (newPriceProduct.innerHTML = data.dataset.price),
        root.style.setProperty("--ff-variant-value", `"${data.innerText}"`),
        opener.setAttribute("data-active", "true")),
        opener.removeAttribute("data-open")
      });
    });

    opener.addEventListener("click", () => {
      errorMsg.setAttribute('hidden', '');

      opener.dataset.open
        ? (opener.removeAttribute("data-open"), variantSwitcher.classList.add("ff-full-section-box"))
        : (opener.setAttribute("data-open", "true"), opener.dataset.active ? variantSwitcher.classList.remove("ff-full-section-box"):
        variantSwitcher.classList.add("ff-full-section-box"));
    });
  }

  hideElement(element) {
    element.remove();
  }

  isInViewport(fixedBox) {
    const element = document.querySelector("product-recommendations") ? 
    document.querySelector("product-recommendations") 
    : document.querySelector("footer");
    const rect = element.getBoundingClientRect();
    rect.top <= rect.height
      ? fixedBox.classList.add("ff-product-box-hide")
      : fixedBox.classList.remove("ff-product-box-hide");
  }
}

customElements.define("ff-product-box", FantasticProductBox);